/**
 * Search page shell entry point.
 *
 * Keeps only the browser behavior needed by the search page chrome and
 * search result images, without loading the full site-wide main.js bundle.
 */

import 'lazysizes'

import whenDomReady from 'when-dom-ready'
import loadWebFonts from './modules/webfonts'
import { addStyledComponentStyles } from './modules/helper-functions'
import initLangMenu from '../components/language-menu/language-menu'
import initSlideNav from '../components/slide-nav/slide-nav'
import initExtranetToolbar from '../components/extranet-toolbar/extranet-toolbar'

/**
 * Replace the no-js html class without loading the full Modernizr bundle.
 */
const enableJsClass = () => {
  document.documentElement.className = document.documentElement.className.replace( /(^|\s)no-js(\s|$)/, '$1js$2' )
}

enableJsClass()
loadWebFonts()

whenDomReady().then(() => {
  document.body.classList.remove( 'preload' )

  initLangMenu()
  initSlideNav()
  initExtranetToolbar()
  addStyledComponentStyles()
})
